import React from "react";
import { SpinnerDiamond } from "spinners-react";

const LoaderComponent = (props) => {
  const { size, thickness, color, speed, style } = props;
  return <SpinnerDiamond size={size} thickness={thickness} сolor={color} speed={speed} style={style} />;
};

export default LoaderComponent;
